// import './InputFieldWithLabel.scss';

import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { InputField } from '..';
import FieldLabel from '../FieldLabel';

class InputFieldWithLabel extends Component {

    render() {
        const { label, ...rest } = this.props;
        return (
            <div className={'InputFieldWithLabel'}>
                <FieldLabel value={label} />
                <div className={'input'}>
                    <InputField {...rest} />
                </div>
            </div>
        );
    }
}

InputFieldWithLabel.defaultProps = {
};

InputFieldWithLabel.propTypes = {
    label: PropTypes.string,
};


export default InputFieldWithLabel;